import type { StoreData } from "@features/stores/types";
import { formatCityLine, formatStreet } from "@components/store-locator/utils/formatAddress";
import { Text } from "@ecco/ui/text";
import { Flex } from "@ecco/ui/flex";

export const SelectedStoreData = ({ storeData }: { storeData: StoreData }) => {
    return (
        <Flex mt="1" direction={"column"}>
            <Text
                fontSize={["mobileBodyTextSmall", "mobileBodyTextSmall", "desktopBodyTextSmall"]}
                fontWeight="bold"
            >
                {storeData.name}
            </Text>
            <Text fontSize={["mobileBodyTextTiny", "mobileBodyTextTiny", "desktopBodyTextTiny"]}>
                {formatStreet(storeData)} {formatCityLine(storeData)}
            </Text>
        </Flex>
    );
};
